import { CONTACTS } from "../data/content";
import { Reveal } from "./Reveal";

export const Contact = () => (
    <footer id="contact" className="pt-28 md:pt-44 scroll-mt-24" data-testid="contact-section">
        <div className="px-6 md:px-12">
            <Reveal>
                <p className="font-mono2 text-[10px] md:text-xs tracking-[0.3em] text-[var(--mute)] uppercase mb-6">
                    06 — Contact
                </p>
                <h2 className="font-display uppercase leading-[0.95] tracking-tight text-4xl sm:text-6xl md:text-8xl" data-testid="contact-title">
                    Marco
                    <br />
                    Giavazzi
                </h2>
                <p className="mt-6 font-mono2 text-[10px] md:text-xs tracking-[0.25em] text-[var(--mute)] uppercase" data-testid="contact-tagline">
                    Graphic / Communication / Fashion
                </p>
            </Reveal>

            <div className="mt-16 md:mt-24 border-t border-[var(--line)]">
                {CONTACTS.map((c) => (
                    <a
                        key={c.id}
                        href={c.href}
                        target={c.id === "instagram" ? "_blank" : undefined}
                        rel={c.id === "instagram" ? "noopener noreferrer" : undefined}
                        data-testid={`contact-${c.id}-link`}
                        className="link-row group flex items-baseline justify-between gap-6 py-6 md:py-8 border-b border-[var(--line)]"
                    >
                        <span className="font-mono2 text-[10px] md:text-xs tracking-[0.3em] text-[var(--mute)] group-hover:text-[var(--ink)] uppercase">
                            {c.label}
                        </span>
                        <span className="font-display text-lg sm:text-2xl md:text-4xl uppercase tracking-tight text-right break-all">
                            {c.value}
                        </span>
                    </a>
                ))}
            </div>

            <div className="py-8 flex items-center justify-between font-mono2 text-[9px] md:text-[10px] tracking-[0.2em] text-[var(--mute)] uppercase">
                <span>© 2026 Marco Giavazzi</span>
                <span className="font-script normal-case text-base md:text-lg tracking-normal -rotate-2">worst portfolio in town</span>
            </div>
        </div>
    </footer>
);
